var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table',[_c('tbody',[_c('tr'),_c('tr',[_c('td',[_c('p',{staticClass:"content"},[_vm._t("content")],2)])]),_c('tr',[_c('td',[_c('p',{staticClass:"english"},[_vm._t("english")],2)])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }